import { ERP } from '../_base/endpoint';
import global from '../../common/utility/global';
import axios from 'axios';

class padronReducidoService {
    /******* QUERIES ******/

    async factura(numeroDocumento) {
        const url = `${ERP}integracion/padron-reducido/factura/${numeroDocumento}`;
        const response = await axios
            .get(url)
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
                return error.response ? error.response : {};
            });
        return response;
    };

    async boleta(numeroDocumento) {
        const url = `${ERP}integracion/padron-reducido/boleta/${numeroDocumento}`;
        const response = await axios
            .get(url)
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
                return error.response ? error.response : {};
            });
        return response;
    };

    async ncnd(numeroDocumento) {
        const url = `${ERP}integracion/padron-reducido/ncnd/${numeroDocumento}`;
        const response = await axios
            .get(url)
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
                return error.response ? error.response : {};
            });
        return response;
    };

    async obtener(filter) {
        const url = `${ERP}integracion/padron-reducido?${global.formatParameter(filter)}`;
        const response = await axios
            .get(url)
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
                return error.response ? error.response : {};
            });
        return response;
    };

    async entidad(filter) {
        const url = `${ERP}integracion/padron-reducido/entidad/?${global.formatParameter(filter)}`;
        const response = await axios
            .get(url)
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
                return error.response ? error.response : {};
            });
        return response;
    };

    async logistica_entidad(numeroDocumento) {
        const url = `${ERP}integracion/padron-reducido/logistica-entidad/${numeroDocumento}`;
        const response = await axios
            .get(url)
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
                return error.response ? error.response : {};
            });
        return response;
    };

    async logistica_proveedor(numeroDocumento) {
        const url = `${ERP}integracion/padron-reducido/logistica-proveedor/${numeroDocumento}`;
        const response = await axios
            .get(url)
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
                return error.response ? error.response : {};
            });
        return response;
    };

    async tesoreria_empleado(numeroDocumento) {
        const url = `${ERP}integracion/padron-reducido/tesoreria-empleado/${numeroDocumento}`;
        const response = await axios
            .get(url)
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
                return error.response ? error.response : {};
            });
        return response;
    };


    async obtenerDniApi(numeroDocumento) {
        const url = `${ERP}integracion/padron-reducido/servicio/dni/${numeroDocumento}`;
        const response = await axios
            .get(url)
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
                return error.response ? error.response : {};
            });
        return response;
    };

    

    async obtenerRucApi(numeroDocumento) {
        const url = `${ERP}integracion/padron-reducido/servicio/ruc/${numeroDocumento}`;
        const response = await axios
            .get(url)
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
                return error.response ? error.response : {};
            });
        return response;
    };


    async obtenerProveedorDniApi(numeroDocumento) {
        const url = `${ERP}integracion/padron-reducido/logistica-proveedor/dni/${numeroDocumento}`;
        const response = await axios
            .get(url)
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
                return error.response ? error.response : {};
            });
        return response;
    };

    

    async obtenerProveedorRucApi(numeroDocumento) {
        const url = `${ERP}integracion/padron-reducido/logistica-proveedor/ruc/${numeroDocumento}`;
        const response = await axios
            .get(url)
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
                return error.response ? error.response : {};
            });
        return response;
    };

}

export default new padronReducidoService();